import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paginationContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      marginTop: (props: any) =>
        props.paginationPosition === 'bottom' ||
        props.paginationPosition === 'both'
          ? theme.spacing(3)
          : 0,
      marginBottom: (props: any) =>
        props.paginationPosition === 'top' ||
        props.paginationPosition === 'both'
          ? theme.spacing(3)
          : 0,
      justifyContent: (props: any) => {
        switch (props.paginationAlignment) {
          case 'left':
            return 'flex-start';
          case 'center':
            return 'center';
          case 'right':
          default:
            return 'flex-end';
        }
      },
    },
    paginationDataLabel: {
      fontSize: 14,
      color: theme.palette.text.secondary,
      fontWeight: 'bold',

      '& + p': {
        marginRight: theme.spacing(2),
      },
    },
    skeleton: {
      transform: 'none',
      marginRight: theme.spacing(2),
    },
  }),
);

export default useStyles;
